import styled, { css } from 'styled-components';
import Flex from '../../atoms/Flex';
import Box from '../../atoms/Box';
const directionRowStyle = css`
  overflow-y: hidden;

  > *:not(:first-child) {
    margin-left: 8px;
  }
`;
const directionColumnStyle = css`
  overflow-x: hidden;

  > *:not(:first-child) {
    margin-top: 8px;
  }
`;

const addDirectionStyle = ({
  directionType
}) => directionType === 'row' ? directionRowStyle : directionColumnStyle;

export const LinksContent = styled(Flex).attrs(({
  directionType
}) => ({
  pb: '1em',
  flexDirection: directionType
}))`
  ${({
  directionType
}) => directionType === 'column' && `
      padding: 1em;
  `}

  ${addDirectionStyle};
`;
export const ShowMore = styled(Box).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  text-decoration: underline;
  cursor: pointer;
`;